/*
  Cart "Product list" slider — reposition fix (drawer)

  The bug only happens in the cart DRAWER: the drawer is hidden (width 0)
  when Flickity initialises, so it stores wrong cell measurements and the
  slides get cut off. A plain "reposition" is not enough because the stored
  sizes are already wrong — we must force Flickity to RE-MEASURE the cells
  (resize + reloadCells) once the drawer is actually visible.

  slider-component stores its Flickity instance on `el.flkty`, so we call
  those methods directly.
*/
(function () {
  var SLIDER_SELECTOR =
    '.cart__widget__products--slider slider-component[data-slider]';

  function remeasure(slider) {
    if (!slider) return;
    var f = slider.flkty;
    if (f && typeof f.resize === 'function') {
      try {
        f.resize();
        if (typeof f.reloadCells === 'function') f.reloadCells();
        if (typeof f.reposition === 'function') f.reposition();
      } catch (e) {
        /* no-op */
      }
    } else {
      // Flickity not ready yet — fall back to the theme event.
      slider.dispatchEvent(
        new CustomEvent('theme:slider:reposition', { bubbles: false })
      );
    }
  }

  // Re-measure several times across the drawer's open animation, because
  // the slider goes from width 0 to its real width during that window.
  function remeasureRepeatedly(slider) {
    if (!slider) return;
    [0, 60, 150, 300, 500, 750, 1000].forEach(function (delay) {
      setTimeout(function () {
        requestAnimationFrame(function () {
          remeasure(slider);
        });
      }, delay);
    });
  }

  function remeasureAll() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(remeasureRepeatedly);
  }

  // Watch images so we also re-measure once they finish loading.
  function watchImages(slider) {
    if (!slider || slider.dataset.cartSliderImgWatched) return;
    slider.dataset.cartSliderImgWatched = 'true';
    slider.querySelectorAll('img').forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) return;
      var done = function () {
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
        remeasure(slider);
      };
      img.addEventListener('load', done);
      img.addEventListener('error', done);
    });
  }

  function initWatchers() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(watchImages);
  }

  // THE IMPORTANT ONE: when the cart drawer opens, the slider becomes
  // visible and must be re-measured from scratch.
  document.addEventListener('theme:cart-drawer:open', function () {
    initWatchers();
    remeasureAll();
  });

  // Fallback: observe the cart-drawer element for the is-open class, in
  // case the open event timing differs.
  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.cartSliderObserved) return;
    drawer.dataset.cartSliderObserved = 'true';
    var mo = new MutationObserver(function () {
      if (drawer.classList.contains('is-open')) {
        initWatchers();
        remeasureAll();
      }
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  // Cart re-renders (add to cart, qty change) replace the markup.
  document.addEventListener('theme:cart:change', function () {
    setTimeout(function () {
      initWatchers();
      remeasureAll();
    }, 60);
  });
  document.addEventListener('theme:product:added', function () {
    setTimeout(function () {
      initWatchers();
      remeasureAll();
    }, 60);
  });

  // The theme's own "slider loaded" signal.
  document.addEventListener('theme:slider:loaded', function (e) {
    var slider = e && e.detail && e.detail.slider;
    if (slider && slider.closest('.cart__widget__products--slider')) {
      remeasureRepeatedly(slider);
    }
  });

  function boot() {
    initWatchers();
    observeDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();